var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackToBeatportArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56027 0.854881L2.33014 3.89446L9 3.85884V5.14116L2.33014 5.10554L5.56027 8.14512L4.6726 9L0 4.5L4.6726 0L5.56027 0.854881Z",
    fill: "#A6A6A6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackToBeatportArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-to-beatport-arrow.d653854add5a37d8040e6248f62cc157.svg";